import { USE_API } from '../config/env';
import { useAppSelector } from '../store/hooks';

/** Public store settings name when `USE_API`; otherwise fixed label. */
export function useStoreBrandName() {
  const name = useAppSelector((s) => s.storeSettings.settings?.name);
  if (!USE_API) return 'Moda MAI';
  const t = typeof name === 'string' ? name.trim() : '';
  return t || 'Moda MAI';
}
